import type { LeavePeriod } from '@trinnvis/dabih-api-client';
import { LeavePeriodDayLeaveStatusEnum } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import { crop } from './crop';
import { sortBy } from 'lodash';
import type { PeriodWithSubPeriods } from './period-with-sub-periods';

/**
 * Takes a list of periods and a date for year start and end
 * Returns the list cropped to the year
 */
export function leavePeriodsForYear(p: LeavePeriod[], yearStartDate: LocalDate, yearEndDate: LocalDate) {
  const value = p
    .filter(
      (period) =>
        period.start.startsWith(yearStartDate.year() + '') || period.end.startsWith(yearStartDate.year() + ''),
    )
    .map((period) => {
      const periodStartDate = LocalDate.fromString(period.start);
      const periodEndDate = LocalDate.fromString(period.end);
      const cropped = crop(yearStartDate, yearEndDate, periodStartDate, periodEndDate);
      const pp: PeriodWithSubPeriods = {
        start: cropped.startDate.toString(),
        startTime: period.startTime,
        end: cropped.endDate.toString(),
        endTime: period.endTime,
        type: period.type,
        grade: period.grade,
        days: period.days,
        confirmed: period.confirmed,
        notes: period.notes,
        uuid: period.uuid,
        subPeriods: [],
      };
      // Convert work days in graded leave to periods
      if (period.grade < 100 && period.days && period.days.length) {
        pp.subPeriods = period.days
          .filter(
            (day) =>
              day.leaveStatus === LeavePeriodDayLeaveStatusEnum.Work &&
              LocalDate.fromString(day.date).isSameOrAfter(yearStartDate) &&
              LocalDate.fromString(day.date).isSameOrBefore(yearEndDate),
          )
          .map((day) => ({
            start: day.date,
            startTime: day.start,
            end: day.date,
            endTime: day.end,
            type: 'work',
            grade: 100,
            confirmed: true,
            notes: '',
          }));
      }
      return pp;
    });
  return sortBy(value, [(e) => e.type, (e) => e.start]);
}
